/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Toolcardfailed2Inputs */

const en_toolcardfailed2 = /** @type {(inputs: Toolcardfailed2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✗ tool call failed: ${i?.error}`)
};

const pt_toolcardfailed2 = /** @type {(inputs: Toolcardfailed2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✗ chamada falhou: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "✗ tool call failed: {error}" |
*
* @param {Toolcardfailed2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardfailed2 = /** @type {((inputs: Toolcardfailed2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardfailed2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardfailed2(inputs)
	return pt_toolcardfailed2(inputs)
});
export { toolcardfailed2 as "toolCardFailed" }